module.exports = __webpack_public_path__ + "images/signal_4.af859d7c79ec190f734d487d2b4a010f.png";